export default [
  {
    path: "/FengShanHangDao",
    meta: { title: "丰山巷道", vis: false },
    component: (resolve) =>
      require(["../../views/case/FengShanHangDao.vue"], resolve),
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/case.js